import AxiosInstance from "@/api";

export interface ManualSubscribePayload {
    userId: number;
    planId: number;
    startFrom: string;
}

export const manualSubscribe = async (body: ManualSubscribePayload) => {
    const result = await AxiosInstance.post("/subscriptions/manual-subscribe", body);
    return result.data;
};
